export class Chapter {
  constructor({ chapter }) {
    this.bookId = chapter["book_id"];
    this.chapterNumber = chapter["chapter_number"];
    this.content = chapter["content"];
    this.createdAt = chapter["created_at"] || new Date().toISOString();
    this.id = chapter["id"];
    this.title = chapter["title"];
    this.updatedAt = chapter["updated_at"] || new Date().toISOString();
    this.word_count_trigger = chapter["word_count_trigger"];
  }
}

export class Book {
  constructor({ book }) {
    this.id = book["id"];
    this.time_posted = book["time_posted"];
    this.time_updated = book["time_updated"];
    this.title = book["title"];
    this.chapters = book["chapters"].map((chapter) => new Chapter({ chapter }));
    this.role = book["role"];
    this.target_word_count = book["target_word_count"];
    this.counts_toward_stats = book["counts_toward_stats"];
    this.atlas_auto_refresh = book["atlas_auto_refresh"];
    this.chat_memory = book["chat_memory"];
  }
}

export function convertToBookObject(data) {
  return data["books"].map((book) => new Book({ book }));
}

export function convertToChapterObject(data) {
  return new Chapter({ chapter: data });
}
